import { motion } from "framer-motion";
import { useStore } from "../context/StoreContext";
import { fmtPrice, prodName } from "../data/products";

export const ProductCard = ({ p, index = 0 }) => {
  const { L, lang, setQuickView, addToCart } = useStore();
  const name = prodName(p, lang);

  return (
    <motion.article
      initial={{ opacity: 0, y: 30 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, amount: 0.15 }}
      transition={{ duration: 0.7, delay: (index % 4) * 0.08, ease: [0.22, 1, 0.36, 1] }}
      className="group"
      data-testid={"product-card-" + p.slug}
    >
      <div
        className="relative cursor-pointer overflow-hidden rounded-t-[999px] rounded-b-xl border border-gold/20 group-hover:border-gold/60 transition-colors duration-500 bg-onyx"
        onClick={() => setQuickView(p)}
        data-testid={"product-image-" + p.slug}
      >
        <img
          src={p.image}
          alt={name}
          loading="lazy"
          className="w-full object-cover aspect-[3/4] transition-transform duration-[1.2s] ease-out group-hover:scale-[1.06]"
        />
        <div className="absolute inset-0 opacity-0 group-hover:opacity-100 transition-opacity duration-500" style={{ background: "radial-gradient(60% 45% at 50% 32%, rgba(212,175,55,0.22), transparent 70%)" }} />
        <div className="absolute inset-x-4 bottom-4 opacity-0 translate-y-3 group-hover:opacity-100 group-hover:translate-y-0 transition-all duration-500">
          <button
            data-testid={"product-quick-view-" + p.slug}
            onClick={(e) => {
              e.stopPropagation();
              setQuickView(p);
            }}
            className="w-full btn-ghost backdrop-blur-sm bg-obsidian/50 rounded-full py-2.5 text-[0.65rem] tracking-[0.25em] uppercase"
          >
            {L.shop.quickView}
          </button>
        </div>
      </div>

      <div className="pt-4 px-1 flex items-start justify-between gap-3">
        <div>
          <h3 className="font-display text-lg text-ivory leading-snug" data-testid={"product-name-" + p.slug}>{name}</h3>
          <p className="text-[0.65rem] tracking-[0.2em] uppercase text-sand mt-1" data-testid={"product-size-" + p.slug}>{L.shop.size}</p>
          <p className="flex items-center gap-1.5 text-[0.62rem] text-emerald-300/70 mt-1" data-testid={"product-stock-" + p.slug}>
            <span className="w-1 h-1 rounded-full bg-emerald-400/80" />
            {L.shop.inStock}
          </p>
        </div>
        <div className="text-right shrink-0">
          <p className="text-gold font-display" data-testid={"product-price-" + p.slug}>{fmtPrice(p.price, lang)}</p>
          <button
            data-testid={"product-add-" + p.slug}
            onClick={() => addToCart(p.slug, 1)}
            className="mt-1.5 text-[0.62rem] tracking-[0.2em] uppercase text-ivory/70 hover:text-gold transition-colors border-b border-gold/30 hover:border-gold pb-0.5"
          >
            {L.shop.add}
          </button>
        </div>
      </div>
    </motion.article>
  );
};
